import React from 'react';
import { House } from '@phosphor-icons/react';

const ROOT_CRUMB = { id: null, name: 'Raíz' };

const FileExplorerBreadcrumb = ({ items = [], onNavigate }) => {
  const allCrumbs = [ROOT_CRUMB, ...items];

  return (
    <nav
      className="flex items-center flex-wrap gap-1.5 px-4 py-3 font-semibold text-content min-w-0"
      aria-label="Ruta actual"
    >
      {allCrumbs.map((crumb, index) => {
        const isLast = index === allCrumbs.length - 1;
        const isRoot = crumb.id === null;

        return (
          <React.Fragment key={crumb.id ?? 'root'}>
            {index > 0 && <span className="text-muted-deep">/</span>}
            <span
              className={`inline-flex items-center ${
                isLast
                  ? 'text-content'
                  : 'text-content-muted hover:text-accent-text cursor-pointer transition-colors'
              }`}
              onClick={isLast ? undefined : () => onNavigate(crumb.id)}
              title={isRoot ? 'Raíz' : undefined}
              aria-label={isRoot ? 'Raíz' : undefined}
            >
              {isRoot ? <House size={16} weight={isLast ? 'fill' : 'regular'} /> : crumb.name}
            </span>
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default FileExplorerBreadcrumb;
